import React, { useEffect, useRef } from 'react';
import type { FunctionComponent, RefObject, ReactNode } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

import './ScrollBar.scss';

interface RenderThumbParameters {
	style: { [key: string]: string };
}

interface ScrollBarProps {
	scrollBarElem?: RefObject<Scrollbars>;
	children: ReactNode;
}

export const ScrollBar: FunctionComponent<ScrollBarProps> = ({ scrollBarElem, children }) => {
	const renderThumb = ({ style, ...props }: RenderThumbParameters) => (
		<div style={{ ...style }} className="scrollBar" {...props} />
	);
	const contentWrapper = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (!contentWrapper.current) return;
		const elem = contentWrapper.current;

		const observer = new ResizeObserver(() => {
			scrollBarElem?.current?.forceUpdate();
		});
		observer.observe(elem);

		return () => {
			observer.unobserve(elem);
		};
	}, [scrollBarElem, contentWrapper]);

	return (
		<Scrollbars
			ref={scrollBarElem}
			className="scrollBar__wrapper"
			hideTracksWhenNotNeeded={true}
			renderThumbVertical={renderThumb}
			renderThumbHorizontal={renderThumb}
		>
			<div ref={contentWrapper}>{children}</div>
		</Scrollbars>
	);
};
